<template>
    <div>
        <v-modal-contents ref="modal_contents_agree">

            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title">
                    <div class="h2_title">Условия использования персональных данных</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="terms"></div>
                    <div class="mt-30">
                        <button class="px-30 btn-red"
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>

        <v-form ref="form" class="vacancy-form" v-model="valid" lazy-validation>

            <div class="row mx-0 my-0">
                <slot name="description">
                    <div class="col-12 col-md-6 col-lg-6 p-md-2">
                    </div>
                </slot>
                <div class="col-12 col-md-6 col-lg">
                    <div class="row">
                        <div class="col-12 col-md-12 pb-3 px-3 pt-3">
                            <div class="vacancy-form__item">

                                <v-text-field
                                        v-model="position"
                                        :readonly="!!jobPosition"
                                        :rules="[rules.required]"
                                        required=""
                                        class="vacancy-form__input"
                                        id="position"
                                >
                                    <template v-slot:label>
                                        Предполагаемая должность *
                                    </template>
                                </v-text-field>
                            </div>
                        </div>

                        <div class="col-12 col-md-12 px-3 pt-3 mb-8 position-relative ">
                            <div class="vacancy-form__item position-relative">
                                <div
                                        class="summary  "
                                        :class="{ 'has-error': fileError, 'shake-animation': fileError }"
                                        @dragover="dragover"
                                        @dragleave="dragleave"
                                        @drop="drop"
                                        id="summary"
                                >
                                    <input
                                            type="file"
                                            multiple
                                            name="fields[assetsFieldHandle][]"
                                            id="assetsFieldHandle"
                                            class="w-px h-px opacity-0 overflow-hidden absolute"
                                            @change="onChange"
                                            ref="file"
                                            accept=".pdf,.jpg,.jpeg,.png,.rtf,.doc,.docx,.xls,.xlsx"
                                    />

                                    <label for="assetsFieldHandle" class="block cursor-pointer summary__filelist">
                                        <div class="summary__label">Прикрепите резюме *</div>
                                    </label>
                                    <div class="summary__desc">Файл в формате PDF, DOC, DOCX, RTF, JPG</div>

                                    <ul class="m-0" v-if="this.filelist.length" v-cloak>
                                        <li class="text-sm p-1 text-left" v-for="(file, index) in filelist"
                                            :key="index">
                                            {{ file.name }}
                                            <button
                                                    class="ml-2 summary__remove_file"
                                                    type="button"
                                                    @click="remove(filelist.indexOf(file))"
                                                    title="Remove file">
                                                Удалить
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-if="fileError" class="summary__error-message">
                                Загрузите файл
                            </div>
                        </div>

                        <div class="col-12 col-md-12 pb-3 px-3 pt-3">
                            <!-- SmartCaptcha -->
                            <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                                 class="w-100 mt-30"></div>
                            <div class="formNew_wrap__item  mt-30">
                                <v-checkbox
                                        v-model="checkbox"
                                        :rules="[(v) => !!v || 'Обязательное поле']"
                                        required
                                        color="red"
                                >
                                    <template v-slot:label>
                                        <div class="customLabelForm">
                                            Я выражаю согласие с
                                            <a href="javascript:void(0);" target="_blank"
                                               @click="$refs.modal_contents_agree.modal_open('scroll_false')">
                                                условиями использования
                                            </a>
                                            моих персональных данных для обработки данного обращения
                                            ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область,
                                            г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю
                                            согласие с
                                            <a :href="policy" @click="linkOpen(policy)" class="position-relative zi-1">
                                                Политикой конфиденциальности
                                            </a> и
                                            <a :href="agreement" @click="linkOpen(agreement)"
                                               class="position-relative zi-1">
                                                Пользовательским соглашением.</a>
                                        </div>
                                    </template>
                                </v-checkbox>
                                <v-checkbox
                                        v-model="consentToInform"

                                        color="red"
                                        class="mt-0"
                                >
                                    <template v-slot:label>
                                        <div class="customLabelForm">
                                            Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                                            предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес:
                                            141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,
                                            этаж 2) и
                                            партнеров.
                                        </div>
                                    </template>
                                </v-checkbox>

                                <div class=" d-flex align-items-center  ">
                                    <v-btn :disabled="!valid" class="btn-red w-mc"
                                           @click="sendForm">
                                        Отправить
                                    </v-btn>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>


            </div>

        </v-form>
    </div>

</template>
<script>
import VModalContents from "./modal_contents";

export default {
  components: {
    VModalContents,
  },

  name: "vacancyForm",

  props: {
    jobPosition: String,
    directions: Array | String | Number | Boolean | Object,
    policy: String | Boolean,
    agreement: String | Boolean,
    terms: String | Boolean,
  },

  data() {
    return {
      captchaPassed: false,
      captchaToken: "",

      valid: false,

      rules: {
        required: value => !!value || "Обязательное поле",
      },

      position: "",
      checkbox: false,
      consentToInform: false,

      filelist: [],
      fileError: false,
    };
  },

  methods: {
    linkOpen(url) {
      window.open(url, "_blank");
    },

    // ================= CAPTCHA =================

    initCaptcha() {
      window.smartCaptcha.render("captcha-container", {
        sitekey: "ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1",
        callback: (token) => this.onCaptchaSuccess(token),
      });
    },

    onCaptchaSuccess(token) {
      this.captchaPassed = true;
      this.captchaToken = token;
    },

    // ================= SEND FORM =================

    sendForm() {
      const isFieldsValid = this.$refs.form.validate();
      const isFileMissing = this.filelist.length === 0;

      if (isFileMissing) {
        this.fileError = false;
        this.$nextTick(() => {
          this.fileError = true;
        });
      } else {
        this.fileError = false;
      }

      if (!isFieldsValid || isFileMissing || !this.captchaPassed) {
        return;
      }

      const formData = new FormData();

      this.filelist.forEach((file, index) => {
        formData.append(index, file);
      });

      formData.append("position", this.position);
      formData.append("captchaToken", this.captchaToken);
      formData.append(
          "consentToInform",
          this.consentToInform ? "Y" : "N"
      );
      formData.append("ajaxPost", "Y");

      fetch("/ajax/vacancy-send.php", {
        method: "POST",
        body: formData,
      })
          .then(response => response.json())
          .then(data => {
            console.log(data);

            // при необходимости очистить форму
            // ym(88483883, 'reachGoal', 'Successful form completion'); // счетчика тут не будет

            $(".text_result_new .send__title").text("Письмо отправлено");
            // $(".text_result_new .send__subtitle").text("Мы ответим Вам в ближайшее время.");
            $(".text_result_new").slideDown(300);

            this.reset();
            this.filelist = [];
            this.captchaPassed = false;
            this.captchaToken = "";

          })
          .catch(err => {
            console.error(err);
          });
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },

    // ================= FILE =================

    onChange() {
      this.filelist = [...this.$refs.file.files];

      if (this.filelist.length > 0) {
        this.fileError = false;
      }
    },

    remove(i) {
      this.filelist.splice(i, 1);

      if (this.filelist.length === 0) {
        this.fileError = true;
      }
    },

    dragover(event) {
      event.preventDefault();

      if (!event.currentTarget.classList.contains("bg-green-300")) {
        event.currentTarget.classList.remove("bg-gray-100");
        event.currentTarget.classList.add("bg-green-300");
      }
    },

    dragleave(event) {
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
    },

    drop(event) {
      event.preventDefault();

      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();

      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");

      if (this.filelist.length > 0) {
        this.fileError = false;
      }
    },
  },

  mounted() {
    setTimeout(() => {
      this.initCaptcha();
    }, 500);
  },

  watch: {
    captchaPassed(value) {
      this.valid = value;
    },

    jobPosition: {
      immediate: true,
      handler(newValue) {
        this.position = newValue;
      },
    },
  },
};
</script>
<style scoped lang="scss">
.vacancy-form {
  padding: 20px;
  border-radius: 40px;
  background: #F5F5F7;

  &__input {
    width: auto;
    border: 1px solid #E2E2E2;
    border-radius: 6px;
    padding: 21px 15px !important;
    margin: 0 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #282828;
    resize: none;
    background: #FFFFFF;
  }


  & .smart-captcha.error-captcha:before {
    background: transparent;
  }

  & .summary {
    position: relative;
    text-align: center;
    background: #ffffff;
    border: 1px dashed #4F4F4F;
    border-radius: 6px;
    color: rgba(0, 0, 0, 0.87);
    padding: 35px;

    &.has-error {
      border: 1px dashed #FA4237;
    }

    &.shake-animation {
      animation: shakeEffect 0.4s ease-in-out;
    }


    @keyframes shakeEffect {
      0%, 100% {
        transform: translateX(0);
      }
      20%, 60% {
        transform: translateX(-6px);
      }
      40%, 80% {
        transform: translateX(6px);
      }
    }

    &__filelist {
      margin-bottom: 0;
      width: 100%;

      &:hover {
        opacity: 0.8;
      }
    }

    &__label {
      color: #FA4237;
      font-family: 'RobotoRegular';
      font-weight: 400;
      font-size: 16px;
      line-height: 120%;
      letter-spacing: 0px;
      margin-bottom: 0;
      width: 100%;
    }

    &__desc {
      position: absolute;
      bottom: -25px;
      left: 0px;
      font-family: 'RobotoRegular';
      font-weight: 400;
      font-size: 14px;
      line-height: 120%;
      letter-spacing: 0px;
      color: #4F4F4F;
      text-align: left;

      @media (max-width: 425px) {
        bottom: -37px;
      }
    }

    &__error-message {
      position: absolute;
      bottom: -40px;
      font-family: 'RobotoRegular';
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: -0.05px;
      color: #FA4237;


    }

    &__remove_file {
      &:hover {
        opacity: 0.8;
      }
    }
  }
}

</style>

<style lang="scss">
.vacancy-form {

  &__h2 {
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-size: 52px;
    line-height: 68px;
    letter-spacing: -1.04px;
    vertical-align: middle;

    @media (max-width: 1000px) {
      font-size: 46px;
      line-height: 56px;
    }

    @media (max-width: 650px) {
      font-size: 38px;
      line-height: 44px;
    }

    @media (max-width: 500px) {
      font-size: 30px;
      line-height: 36px;
    }
  }

  &__p {
    font-family: "RobotoRegular";
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0px;
    color: #212424;
    margin: 0;

    @media (max-width: 650px) {
      font-size: 24px !important;
      line-height: 30px !important;
    }

    @media (max-width: 500px) {
      font-size: 20px !important;
      line-height: 24px !important;
    }
  }

  &__link {
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-size: 52px;
    line-height: 68px;
    letter-spacing: -1.04px;
    color: #212424 !important;
    width: max-content;

    @media (max-width: 768px) {
      font-size: 40px !important;;
      line-height: 46px !important;;
    }

    @media (max-width: 650px) {
      font-size: 40px !important;;
      line-height: 46px !important;;
    }

    @media (max-width: 500px) {
      font-size: 30px !important;
      line-height: 36px !important;
      margin-bottom: 20px !important;
    }
  }

  & #captcha-container-footer, #captcha-container {
    @media (max-width: 425px) {
      min-width: 200px;
    }
  }

  & .smart-captcha.error-captcha:before {
    top: -25px;
  }

  & .vacancy-form__item .primary--text {
    color: #656565 !important;
    caret-color: #656565 !important;
  }

  & .v-text-field__details {
    position: absolute;
    display: flex;
    transform: translate(-1px, 38px);
  }

  & .v-text-field input {

    @media (max-width: 500px) {
      font-size: 12px;
    }

    &:read-only {
      background: #EFEFEF;
      color: #A4A4A4 !important;
    }
  }

  & .v-input--is-readonly {
    background: #EFEFEF;
  }

  & .v-text-field input,
  & .v-text-field .v-label--active {
    &:read-only {
      color: #A4A4A4 !important;
    }
  }

  & .v-application .v-input--is-focused {
    border-color: rgb(79, 77, 85);
  }

  & .v-text-field fieldset, .v-text-field .v-input__control {
    height: 32px;
  }

  & .v-text-field > .v-input__control > .v-input__slot:after,
  & .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    display: none;
  }

  & .v-input.tel_input.form__input.v-input--is-focused .v-label,
  & .v-input.tel_input.form__input.v-input--is-label-active .v-label--active {
    display: none;
  }

  & .v-list-item {
    @media (max-width: 766px) {
      margin-bottom: 10px;
    }
  }

  & .v-btn:not(.v-btn--round).v-size--default {
    height: unset;
  }
}

</style>